import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../../assets/env/env.local';
import { BrandingService } from '../../../services/branding-service/branding.service';

interface NavItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  readonly version = environment.ADMIN_PANEL_VERSION;

  readonly navItems: NavItem[] = [
    { label: 'NAV.DASHBOARD', icon: 'dashboard', route: '/dashboard' },
    { label: 'NAV.USERS', icon: 'people', route: '/users' },
    { label: 'NAV.USER_EVENTS', icon: 'login', route: '/anmeldungen' },
    { label: 'NAV.ORGANISATIONS', icon: 'business', route: '/organisations' },
    { label: 'NAV.DOCUMENTATIONS', icon: 'folder_open', route: '/documentations' },
    { label: 'NAV.TEMPLATES', icon: 'description', route: '/templates' },
    { label: 'NAV.INDUSTRIES', icon: 'category', route: '/industries' },
    { label: 'NAV.PHOTO_METADATA', icon: 'photo_library', route: '/photo-metadata' },
    { label: 'NAV.MAIL_QUEUE', icon: 'mail', route: '/mail-queue' },
    { label: 'NAV.EMAIL_TEMPLATES', icon: 'email', route: '/email-templates' },
  ];

  readonly user$ = this.auth.user$;

  constructor(
    private auth: AuthService,
    readonly branding: BrandingService,
  ) {}

  logout(): void {
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  }
}
